import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {PrincipalService} from '../../../services/principal/principal.service';
import {isDefined} from '../../utils';
import {AuthorityRoles} from '../../../domain/authority-roles';

import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-unauthorised-card',
  imports: [IonicModule, TranslateModule],
  templateUrl: './unauthorised-card.component.html',
  styleUrls: ['./unauthorised-card.component.scss']
})
export class UnauthorisedCardComponent implements OnChanges {
  @Input() authorities: AuthorityRoles[];

  showMessage = false;

  constructor(private readonly principalService: PrincipalService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (isDefined(this.authorities)) {
      this.principalService
        .hasAnyAuthority(this.authorities)
        .subscribe(hasAuthority => this.showMessage = !hasAuthority);
    } else {
      this.showMessage = false;
    }
  }
}
